module.exports = __webpack_public_path__ + "img/run@2x.70be5ad6.png";